import React, { Fragment } from "react";
import { withStyles } from "@material-ui/core";
import ArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import ArrowRight from "@material-ui/icons/KeyboardArrowRight";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { compose } from "recompose";
import {
  generateQuickFilterString,
  clearFilter,
} from "../../../../common/filterUtilities";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";

import Tooltip from "../../../../common/StyledToolTip";
import appConstants from "../../../../../appConstants";
import { RMAXLogger } from "../../../../../services/LoggerService/RMAXLogger";
import FilterContainer from "./FilterContainer";
import styles from "./styles";

class TractorGridFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterObject: {},
      quickFilterIsVisible: true,
      isLoading: false,
      filter: "",
    };
  }
  componentDidMount() {
    this.props.glEventHub.on(
      "toggleQuickFilterVisibility",
      this.props.toggleQuickFilterVisibility
    );

    this.setState(
      {
        filterObject: {},
      },
      this.updateFilter()
    );
  }

  componentWillUnmount() {
    this.props.glEventHub.off(
      "toggleQuickFilterVisibility",
      this.props.toggleQuickFilterVisibility
    );
    this.props.glEventHub.emit(
      "UpdateTractorQuickFilter",
      appConstants.EMPTY_STRING
    );
  }

  // handles hide/collapse for each filter group
  toggleFilterGroupVisibility = ({ groupKey }) => {
    this.setState((state) => ({
      [`${groupKey}_isOpen`]: !state[`${groupKey}_isOpen`],
    }));
  };

  // Render toggle button for button filter and have a handler to change filter applied state
  renderButtonFilter = (filter) => {
    const { classes } = this.props;
    const filterChange = () => {
      filter.isApplied = !filter.isApplied;
      this.updateFilter();
    };
    return (
      <ToggleButton
        key={filter.label}
        selected={filter.isApplied}
        value="filter"
        disabled={filter.isDisabled}
        title={filter.description}
        classes={{
          root: classes.toggleButtonRoot,
          disabled: classes.toggleButtonDisabled,
          selected: classes.toggleButtonSelected,
          label: classes.toggleButtonLabel,
        }}
        onClick={filterChange}
      >
        {filter.label}
      </ToggleButton>
    );
  };

  // Render toggle buttons for toggle filter and have a handler to change filter applied state
  renderSwitchFilter = (filter) => {
    const { classes } = this.props;
    const filterChange = (event, value) => {
      const currentOption = { ...value };
      filter.options.map((option) => {
        if (option.label === currentOption.label) {
          option.isApplied = !option.isApplied;
        } else if (!currentOption.isApplied && option.isApplied) {
          option.isApplied = !option.isApplied;
        }
      });
      this.updateFilter();
    };
    return (
      <ToggleButtonGroup
        exclusive
        key={filter.options.map((option) => option.label).join("_")}
        classes={{ root: classes.toggleButtonGroupRoot }}
        onChange={filterChange}
      >
        {filter.options.map((option) => (
          <ToggleButton
            key={option.label}
            selected={option.isApplied}
            disabled={option.isDisabled}
            title={option.description}
            value={option}
            classes={{
              root: classes.toggleButtonRoot,
              disabled: classes.toggleButtonDisabled,
              selected: classes.toggleButtonSelected,
              label: classes.toggleButtonLabel,
            }}
          >
            {option.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    );
  };

  renderFilterItem = (filter) => {
    switch (filter.actionType) {
      case "switch":
        return this.renderSwitchFilter(filter);
      case "select":
        return this.renderDropdown(filter);
      case "filter":
      default:
        return this.renderButtonFilter(filter);
    }
  };

  // Returns true if any individual filter within a group is Active
  isFilterGroupActive = (filterGroup) => {
    return filterGroup.filters.find((filter) => {
      if (filter.actionType === "switch") {
        return filter.options.find((option) => option.isApplied);
      } else {
        return filter.isApplied;
      }
    });
  };

  // Update the filter string in store based on active filters, which will trigger filter for shipments data
  updateFilter = () => {
    let quickFilterString = appConstants.EMPTY_STRING;
    if (this.state.filterObject) {
      quickFilterString = generateQuickFilterString(
        this.state.filterObject,
        this.props.userData.userProfile.planDate
      );
      this.setState((state) => ({
        filterObject: state.filterObject,
      }));
    }
    this.props.glEventHub.emit("UpdateTractorQuickFilter", quickFilterString);
    RMAXLogger.info("TractorGridFilter", {
      quickFilter: quickFilterString,
    });
  };

  // removes all active filters
  onClear = () => {
    if (this.state.filterObject) {
      this.setState((state) => ({
        filterObject: clearFilter(state.filterObject),
      }));
      this.props.glEventHub.emit(
        "UpdateTractorQuickFilter",
        appConstants.EMPTY_STRING
      );
    }
  };

  isAnyFilterApplied = () => {
    return (
      Object.keys(this.state.filterObject.filterGroups || {})
        .map((key) => {
          return this.isFilterGroupActive(
            this.state.filterObject.filterGroups[key]
          );
        })
        .filter((isActive) => isActive).length > 0
    );
  };

  render() {
    const { classes } = this.props;
    const { filterGroups } = this.state.filterObject || {};
    this.props.glContainer
      .getElement()
      .addClass(this.props.classes.quickFilterContainer);
    return this.props.quickFilterIsVisible ? (
      <Fragment>
        <header className={classes.header} data-automationid="quick-filter">
          <h3 className={classes.headerTitle}> Quick Filters </h3>
          <span className={classes.containerAction} onClick={this.onClear}>
            Clear All
          </span>
        </header>
        <FilterContainer
          classes={classes}
          toggleFilterGroupVisibility={this.toggleFilterGroupVisibility}
          isFilterGroupActive={this.isFilterGroupActive}
          renderFilterItem={this.renderFilterItem}
          filterObject={this.state.filterObject}
          filterGroups={filterGroups}
          isLoading={this.state.isLoading}
          {...this.state}
        />
        <footer
          className={classes.footer}
          onClick={this.props.toggleQuickFilterVisibility}
        >
          <ArrowLeft classes={{ root: classes.footerIcon }} />
          <div className={classes.footerText}>Hide Quick Filters</div>
        </footer>
      </Fragment>
    ) : (
      <Fragment>
        <div
          className={classes.headerPanelcontainer}
          onClick={this.props.toggleQuickFilterVisibility}
        >
          Quick Filters
          {this.isAnyFilterApplied() && (
            <span className={classes.filterApplied}>- Filter Applied</span>
          )}
        </div>
        <footer
          className={classes.footer}
          onClick={this.props.toggleQuickFilterVisibility}
        >
          <Tooltip delay={500} title={"Show Quick Filters"}>
            <ArrowRight classes={{ root: classes.footerIcon }} />
          </Tooltip>
        </footer>
      </Fragment>
    );
  }
}
export default compose(withStyles(styles), withUserProfile)(TractorGridFilter);
